export const PRICE = {
  FREE: 'free'
};
